<template>  
  <v-card style="margin-top: 10px">
    <v-overlay
      :value="loading"
      :absolute="true"
      color="#fff"
      :opacity="1"
      
    >
      <v-progress-circular 
      indeterminate
      :value="60"
      color="blue-grey"
      >  
      </v-progress-circular>
    </v-overlay>
    <v-card-title secondary-title>
      {{ placement.elementName }}
    </v-card-title>
    <v-card-text>
      <v-row
        align="center"
        justify="center"
      >
        <v-item-group
          v-model="placement.typeId"
        >
          <v-item
            v-for="type in types"
            :key="type.id"
            v-slot:default="{ active, toggle }"
          >
            <v-btn
              class="mx-2"
              :input-value="active"
              active-class="indigo white--text"
              depressed
              rounded
              @click="toggle"
            >
              {{ type.name }}
            </v-btn>
          </v-item>
        </v-item-group>
      </v-row>
      
      
      <app-ad-type
        :placement="placement"
        :type="selectedType"
      >
      </app-ad-type>
    
    </v-card-text>
    <v-divider></v-divider>
    <v-row>
      <v-card-title>
        <div style="font-size: 0.8em; margin-left: 15px; margin-right:20px;">
            Is Google AdX blocked
        </div>
        <v-switch v-model="placement.isAdxBlocked"></v-switch>
      </v-card-title>
    </v-row>
    <app-header-bidding
      v-for="ssp in Object.keys(hbConfig)"
      :key="ssp"
      :placement="placement"
      :ssp="ssp"
      :fields="hbConfig[ssp]"
    >
    </app-header-bidding>
    <v-card-actions class="d-flex flex-row-reverse">
      <v-btn 
        @click="save"
        rounded 
        color="success" 
        style="margin: 10px"
        :loading="saveLoading"
        :disabled="saveLoading"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>




<script>
  import axios from 'axios'
  import AdType from './AdType.vue'
  import HeaderBidding from './HeaderBidding.vue'

  export default {
    components: {
      AppAdType: AdType, 
      AppHeaderBidding: HeaderBidding
    },
    props: ['page', 'device', 'element'],
    data(){
      return {
        loading: true,
        placement: {
          typeId : 0
        },
        types : [
          {
            id: 0, 
            name: 'Regular', 
            fields : [
              {name: "nexx360TagId", label: "nexx360TagId", rules: ''},
              {name: "sizes", label: "Sizes",rules: 'arrayRules'},
              {name: "beforeStyle", label: "Before::Style", rules: ''}, 
              {name: "style", label: "Style", rules: ''},
              {name : "targeting", label: "Targeting", rules: 'targetingRules'}
            ]
          },
          {  
            id: 1, 
            name: 'Oop',
            fields : [
              {name: "nexx360TagId", label: "nexx360TagId", rules: ''},
              {name : "targeting", label: "Targeting", rules: 'targetingRules'}
            ]
          },
          {
            id: 2, 
            name: 'Injected', 
            fields : [
              {name: "nexx360TagId", label: "nexx360TagId", rules: ''},
              {name: "sizes", label: "Sizes", rules:""},
              {name: "style", label: "Style", rules: ""},
              {name: "beforeStyle", label: "Before::Style", rules: ""},
              {name: "injectedSelector", label: "Injected Selector", rules: ''},
              {name: "injectedPosition", label: "Injected Position", rules: ''},
              {name: "injectedRepetition", label: "Injected Repetition", rules: ''},
              {name : "targeting", label: "Targeting", rules: 'targetingRules'}
            ]
          },
          {
            id: 3, 
            name: 'Skyscraper', 
            fields : [
              {name: "sizes", label: "Sizes", rules:""},
              {name: "nexx360TagId", label: "nexx360TagId", rules: ''},
              {name: "skyscraperContentDiv", label: "Skyscraper Content Div", rules: ''},
              {name: "skyscraperVerticalOffsetElement", label: "Skyscraper Vertical Offset Element", rules: ''},
              {name: "skyscraperPosition", label: "Skyscraper Position", rules: ''},
              {name: "skyscraperHeaderSelector", label: "Skyscraper Header Selector", rules: ''},
              {name : "targeting", label: "Targeting", rules: 'targetingRules'}
            ]
          },
          {
            id: 4, 
            name: 'Dynamic', 
            fields : [
              {name: "nexx360TagId", label: "nexx360TagId", rules: ''},
              {name: "sizes", label: "Sizes", rules:""},
              {name: "style", label: "Style", rules: ""},
              {name: "beforeStyle", label: "Before::Style", rules: ""},
              {name: "injectedSelector", label: "Injected Selector", rules: ''},
              {name: "injectedMainContentSelector", label: "Main Content Selector", rules: ''},
              {name: "injectedFirstOffsetSelector", label: "First Offset Selector", rules: ''},
              {name: "injectedDensityIndex", label: "Density Index", rules: ''},
              {name: "injectedRepetition", label: "Max Repetition", rules: ''},
              {name : "targeting", label: "Targeting", rules: 'targetingRules'}
            ]
          },

        ],
        activeTypeId: 0,
        hbConfig : {
          appnexus : ['placementId'],
          smart: ['domain', 'siteId', 'pageId', 'formatId'],
          rubicon: ['accountId', 'siteId', 'zoneId', 'position'],
          triplelift: ['inventoryCode'],
          freewheelSsp: ['zoneId'],
          teads: ['pageId', 'placementId'],
          openx: ['domain', 'unit'],
          audienceNetworkNative: ['placementId'],
          audienceNetworkDisplay: ['placementId'],
          gravity: ['placementId'],
          onemobile : ['dcn', 'pos'],
          pubmatic: ['publisherId', 'siteId'],
          justpremium: ['zone','allow'],
          sublime: ['zoneId'],
          adagio: ['site'],
          richaudience: ['pid'],
          smilewanted: ['zoneId'],
          ix: ['siteId'],
          improve: ['placementId'],
          goodad: ['invcode'],
          adyoulike: ['placement']
        },
        saveLoading : false
      }
    },
    created() {
      this.getDataFromApi()
    },

    methods: {
      async getDataFromApi(){
        this.loading = true
        const request = {
          type : "management/placement",
          action : "getDetails",
          data : {pageId : this.page.id, deviceId: this.device.id, elementId: this.element.id }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.placement = response.data
          //this.activeTypeId = parseInt(this.placement.typeId)
          this.loading= false
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
          this.loading = false  
        }
      },
      isJsonString(str) {
        try { JSON.parse(str); } catch (e) { return false; }
        return true;
      },
      async save(){
        this.saveLoading = true;
        if(this.placement.isBannerActive  == false) this.placement.isBannerActive = 0
        if(this.placement.isVideoOutstreamActive  == false) this.placement.isVideoOutstreamActive = 0  
        const request = {
          type : "management/placement",
          action : "save",
          data : this.placement
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          console.log(response.data)
          this.$emit('pageUpdated')
        } catch (e) {
          this.$router.push("/login")
          console.error(e)
        }
        this.saveLoading = false
      }
    },
    computed:{
      selectedType(){
        return this.types[this.types.findIndex(x => x.id === this.placement.typeId)];
      }
    },
    watch: {
      element(){
        this.getDataFromApi()
      }
    }

  }
</script>